import { useState, useEffect } from 'react';

interface BackToTopProps {
  threshold?: number;
}

export default function BackToTop({ threshold = 400 }: BackToTopProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggle = () => setVisible(window.scrollY > threshold);
    window.addEventListener('scroll', toggle, { passive: true });
    return () => window.removeEventListener('scroll', toggle);
  }, [threshold]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-8 right-8 w-11 h-11 flex items-center justify-center bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full hover:bg-primary-600 transition-all duration-300 z-40 cursor-pointer"
      aria-label="回到顶部"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}